import React, { useState } from 'react'
import { DEFAULT_FIELD_RULE, FieldRule } from '../../features/declaration/models/fieldRules'

interface ColumnProps {
  columnId: string
  headingLabel: string
  initialIsSectionOpen?: boolean
  collapsible?: boolean
  fieldRule?: FieldRule
}

function FormCollapsibleColumn({
  columnId,
  headingLabel,
  children,
  initialIsSectionOpen,
  collapsible = true,
  fieldRule = DEFAULT_FIELD_RULE,
} : React.PropsWithChildren<ColumnProps>) {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean>(!!initialIsSectionOpen)

  const headingLabelClassName = `collapsible-column__heading-label ${fieldRule.requirement === 'required' ? 'required' : ''} ${fieldRule.requirement === 'forbidden' ? 'text-muted cursor--not-allowed' : ''}`

  if (!collapsible) {
    return (
      <div>
        <h3 className="mb-0 w-100">
          <div className="collapsible-column__heading w-100 d-flex justify-content-between align-items-center mb-2">
            <span className={headingLabelClassName}>
              {headingLabel}
            </span>
          </div>
        </h3>
        <div>{children}</div>
      </div>
    )
  }

  return (
    <div>
      <h3 className="mb-0 w-100">
        <button
          type="button"
          className={
            `collapsible-column__heading w-100 d-flex justify-content-between align-items-center ${isSectionOpen ? 'mb-2' : 'mb-0'}`
          }
          data-bs-toggle="collapse"
          data-bs-target={`#${columnId}`}
          aria-expanded={isSectionOpen}
          aria-controls={columnId}
          onClick={() => setIsSectionOpen(!isSectionOpen)}
        >
          <span className={headingLabelClassName}>
            {headingLabel}
          </span>
          <i
            className={`fa ${isSectionOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
            aria-hidden="true"
          />
        </button>
      </h3>
      <div className={`collapse ${isSectionOpen ? 'show' : ''}`} id={columnId}>
        {children}
      </div>
    </div>
  )
}

FormCollapsibleColumn.defaultProps = {
  initialIsSectionOpen: true,
  collapsible: true,
  fieldRule: undefined,
}

export default FormCollapsibleColumn
